module.exports = __webpack_public_path__ + "assets/img/5.24483e85.jpg";